import { create } from 'zustand';
import type { Club } from '../types';

interface ClubDetailState {
  /** Currently selected club id for the detail view */
  selectedClubId: string | null;
  /** Cached club data from the last fetch */
  selectedClub: Club | null;
  /** Updates the selected club id while preserving cached data when possible */
  setSelectedClubId: (id: string | null) => void;
  /** Stores the loaded club record */
  setSelectedClub: (club: Club | null) => void;
  /** Clears the selected club */
  reset: () => void;
}

export const useClubDetailStore = create<ClubDetailState>((set) => ({
  selectedClubId: null,
  selectedClub: null,
  setSelectedClubId: (id) =>
    set((state) => ({
      selectedClubId: id,
      selectedClub: id && state.selectedClub?.id === id ? state.selectedClub : null,
    })),
  setSelectedClub: (club) =>
    set(() => ({
      selectedClubId: club?.id ?? null,
      selectedClub: club ?? null,
    })),
  reset: () => set({ selectedClubId: null, selectedClub: null }),
}));
